// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1KKIR","buttons":"RemoveExpirationActionButtons_buttons__3ZICs"};